import { getChannelAPIPath } from '@treasury/core/http';

WireCompaniesService.$inject = ['$resource', '$http'];

export default function WireCompaniesService($resource, $http) {
    return {
        getAll,
        getDebitAccounts,
        getBeneficiaries,
        getWireConfiguration,
    };

    function getAll(nonDli) {
        return $resource(`${getChannelAPIPath()}wireCompanies/?nonDli=:nonDli`, {
            nonDli: !!nonDli,
        }).query().$promise;
    }

    function getDebitAccounts(id, type) {
        return $resource(`${getChannelAPIPath()}wireCompanies/:id/accounts`, { id, type }).query()
            .$promise;
    }

    function getBeneficiaries(id) {
        return $resource(`${getChannelAPIPath()}wireCompanies/:id/beneficiaries`, { id }).query()
            .$promise;
    }

    function getWireConfiguration() {
        return $http
            .get(`${getChannelAPIPath()}wireCompanies/wireConfiguration`)
            .then(response => response.data);
    }
}
